<template>
  <div>
    <label>Select time</label>
    <VTextField
      v-bind="$attrs"
      solo
      flat
      type="time"
      v-on="$listeners"
    />
  </div>
</template>

<style lang="stylus" scoped>
:deep(input[type="time"])::-webkit-calendar-picker-indicator
  display: none
@import '../stylus/input.styl'
label
  margin-left: 0
.v-input
  width: 80px
</style>

<script lang="ts">
import { defineComponent } from '@mimir/web/compat/vueCompat';
import { VTextField } from 'vuetify/lib';

export default defineComponent({
  name: 'MTimeInput',
  components: {
    VTextField,
  },
  inheritAttrs: false,
});
</script>
